import { createRootRoute, Outlet } from '@tanstack/react-router';


export interface RouterContext {
  auth: {
    isAuthenticated: boolean;
    user: {
      id: string;
      role: string;
      username: string;
      email: string;
    } | null;
  };
}

// 404 Not Found Component for root route
const NotFound = () => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '100vh',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <h1 style={{ fontSize: '3rem', marginBottom: '1rem', color: 'var(--color-text-primary, #1f2937)' }}>
        404
      </h1>
      <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--color-text-primary, #1f2937)' }}>
        Page Not Found
      </h2>
      <p style={{ color: 'var(--color-text-secondary, #6b7280)', marginBottom: '2rem' }}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <a 
        href="/" 
        style={{
          padding: '0.75rem 1.5rem',
          backgroundColor: 'var(--color-accent, #3b82f6)',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '0.5rem',
          fontWeight: '500'
        }}
      >
        Go to Home
      </a>
    </div>
  );
};

export const Route = createRootRoute({
  component: () => (
    <>
      <Outlet />
    </>
  ),
  notFoundComponent: NotFound,
});
